export const sideEnter = (direction = "left") => {
  return {
    initial: { opacity: 0, scale: 0, x: direction === "left" ? "-100%" : "100%" },
    animate: { opacity: 1, scale: 1, x: 0 },
    transition: {
      duration: 0.4,
      scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
    },
  };
};
